import { Component, Input } from '@angular/core';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
@Component({
  selector: 'icon',
  imports: [FontAwesomeModule],
  template: `
    <fa-icon [icon]="icon" [class]="class"></fa-icon>
  `
})
export class IconComponent {
  @Input() icon!: IconProp;
  @Input() class?: string;
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas, far, fab);
  }
}
